<div class="index">
  <div class="container">
    <div class="row justify-content-md-center">
      <app-card *ngFor="let book of books" [Book]="book"></app-card>
    </div>
  </div>
  <app-add-book (addBook)="addBook($event)"></app-add-book>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Title</th>
        <th scope="col">ISBN</th>
        <th scope="col">Author</th>
        <th scope="col">Description</th>
        <th scope="col">Published Date</th>
        <th scope="col">Publisher</th>
        <th scope="col">Updated Date</th>
        <th scope="col">Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let book of books">
        <td>{{ book.title }}</td>
        <td>{{ book.isbn }}</td>
        <td>{{ book.author }}</td>
        <td>{{ book.description }}</td>
        <td>{{ book.published_date }}</td>
        <td>{{ book.publisher }}</td>
        <td>{{ book.updated_date }}</td>
        <td>
          <button
            type="button"
            class="btn btn-outline-danger"
            (click)="onDelete(book)"
          >
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
